import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentLinkExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="customContainer thankyouPage payment-received">
      <div className="thankyouDetails text-center">
        <h2>Payment Link Expired!</h2>

        <div>
          <button
            onClick={() => {
              navigate("/", { replace: true });
            }}
            className="btn btn-primary"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentLinkExpired;
